class Alert {
	alert(message) {
		return new Promise((resolve) => {
			let element = this.render(message);
			$('[data-alert-container]').append(element);
			let modal = bootstrap.Modal.getOrCreateInstance(element);
			modal.show();

			element.addEventListener('hidden.bs.modal', () => {
				modal.dispose();
				element.remove();
				resolve(true);
			});
		})
	}

	confirm(message) {
		return new Promise((resolve) => {
			let element = this.render(message, true);
			document.querySelector('[data-alert-container]').append(element);

			let modal = bootstrap.Modal.getOrCreateInstance(element);
			modal.show();

			element.querySelector('[data-confirm-button="accept"]').focus();
			element.dataset.accepted = false;

			element.querySelectorAll('[data-confirm-button]').forEach((button, index) => {
				button.addEventListener('click', (event) => {
					event.preventDefault();
					element.dataset.accepted = button.dataset.confirmButton == 'accept';
					modal.hide();
				});
			});

			element.addEventListener('hidden.bs.modal', () => {
				modal.dispose();
				let accepted = element.dataset.accepted;
				element.remove();
				resolve(accepted == 'true');
			});
		});
	}

	render(message, isConfirm = false) {
		let footer = '';
		if(isConfirm) {
			footer = `
				<div class="modal-footer">
        			<button type="button" data-confirm-button="decline" class="btn btn-secondary">Annuleren</button>
        			<button type="button" data-confirm-button="accept" class="btn btn-primary">Ok</button>
      			</div>
			`;
		} else {
			footer = `
				<div class="modal-footer">
        			<button type="button" class="btn btn-primary" data-bs-dismiss="modal">Ok</button>
      			</div>
			`;
		}

		let div = document.createElement('div');
		div.classList.add('modal');
		div.classList.add('fade');
		div.setAttribute('tabindex', '-1');
		div.setAttribute('data-bs-backdrop', 'static');
		div.setAttribute('data-bs-keyboard', 'false');
		div.innerHTML = `
  			<div class="modal-dialog">
    			<div class="modal-content">
      				<div class="modal-body">
        				<p>${message}</p>
      				</div>
      				${footer}
    			</div>
  			</div>
		`;
		return div;
	}
}

export default Alert;